export const iconFontAwesomeEnergyIndustry = (
	<i className="fa-solid fa-industry"></i>
);
